import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/login',
      component: () => import(/* webpackChunkName: "login" */ '../components/login'),
      meta: {
        enabled: 'true'
      }
    },
  ]
})

router.afterEach((to, from, next) => {
  window.scrollTo(0, 0);
  window.heartbeatCallback = null;
  //
  // let path = '/#' + to.path
  // if (to.path == '/') {
  //   path = '/'
  // }
  //
  // gtag('event', 'page_view', {
  //   page_path: path,
  //   page_location: window.location.href
  // })
});

if ('-ms-scroll-limit' in document.documentElement.style && '-ms-ime-align' in document.documentElement.style) { // detect it's IE11
  window.addEventListener('hashchange', event => {
    const currentPath = window.location.hash.slice(1)
    if (store.state.route.path !== currentPath) {
      router.push(currentPath)
    }
  }, false)
}

export default router
